/* eslint-disable @typescript-eslint/no-namespace */
import multipleImage, { multipleImageVariants } from './multiple-image';
import gridHero, { gridHeroVariants } from './grid-hero';
import type { Utility } from '../../../types/utility';

export namespace Hero {
  /** Hero Component Variant Keys */
  export type ComponentKeys = 'multipleImage' | 'gridHero';

  /** Hero Components */
  export type Components = {
    /** The GridHero Component Variant Types*/
    GridHero: GridHero.VariantKeys;
    /** The MultipleImage Component Variant Types */
    MultipleImage: MultipleImage.VariantKeys;
  };

  /** Hero Component Variants */
  export type Variants = {
    [CompKey in ComponentKeys]: CompKey extends 'multipleImage'
      ? MultipleImage.Variants
      : CompKey extends 'gridHero'
        ? GridHero.Variants
        : never;
  };

  /** Hero Component Variant Modes */
  export type VariantModes = {
    [CompKey in ComponentKeys]: Utility.VariantModes<
      CompKey extends 'multipleImage' ? MultipleImage.Variants : CompKey extends 'gridHero' ? GridHero.Variants : never
    >;
  };

  /** Hero GridHero Component */
  export namespace GridHero {
    /** Hero GridHero Component Variant Keys */
    export type VariantKeys = 'loweredSub' | 'topSubLeft' | 'topSubRight' | 'extraButtons' | 'extraButtonsReversed';

    /** Hero GridHero Component Variants */
    export type Variants = {
      [Key in VariantKeys]: Utility.CSSProperties;
    };
  }

  /** Hero MultipleImage Component */
  export namespace MultipleImage {
    /** Hero MultipleImage Component Variant Keys */
    export type VariantKeys = 'dark' | 'light';

    /** Hero MultipleImage Component Variants */
    export type Variants = {
      [Key in VariantKeys]: Utility.CSSProperties;
    };
  }

  /** Hero Component Scale Keys */
  export type ScaleKeys = {
    [CompKey in ComponentKeys]: CompKey extends 'multipleImage'
      ? Array<`${CompKey}.${Hero.MultipleImage.VariantKeys}`>
      : CompKey extends 'gridHero'
        ? Array<`${CompKey}.${Hero.GridHero.VariantKeys}`>
        : never;
  };
}

const hero = {
  multipleImage,
  gridHero,
};

export const heroVariants = {
  multipleImage: multipleImageVariants,
  gridHero: gridHeroVariants,
};

export default hero;
